import { Button, DialogDisclosure, Heading } from "@ariakit/react";
import { DialogTrigger } from "@indietabletop/appkit";
import { interactiveText } from "@indietabletop/appkit/common.css.ts";
import type { ReactNode } from "react";
import { button, lacquer } from "../../common/common.css.ts";
import { database } from "../../database.ts";
import arrow1 from "./arrow1.svg";
import arrow2 from "./arrow2.svg";
import arrow3 from "./arrow3.svg";
import arrow4 from "./arrow4.svg";
import arrow5 from "./arrow5.svg";
import arrow6 from "./arrow6.svg";
import { ChooseFactionDialog } from "./ChooseFactionDialog.tsx";
import { arrows, buildMode } from "./style.css.ts";
import { useGangContext } from "./useGang.ts";

export function StandaloneBuildStep(props: {
  stepLabel: string;
  heading: string;
  text: ReactNode;
  button: ReactNode;
}) {
  const { stepLabel, heading, text, button } = props;

  return (
    <div className={buildMode.container({ standalone: true })}>
      <div className={buildMode.content}>
        <img src={arrow1} alt="" className={arrows.arrow1} />
        <img src={arrow2} alt="" className={arrows.arrow2} />
        <img src={arrow3} alt="" className={arrows.arrow3} />
        <img src={arrow4} alt="" className={arrows.arrow4} />
        <img src={arrow5} alt="" className={arrows.arrow5} />
        <img src={arrow6} alt="" className={arrows.arrow6} />

        <div className={buildMode.headerContent}>
          <div className={buildMode.stepLabel()}>{stepLabel}</div>

          <Heading className={buildMode.heading}>{heading}</Heading>

          <div className={buildMode.info}>{text}</div>
        </div>

        {button}
      </div>
    </div>
  );
}

export function BuildStep(props: {
  done: boolean;
  stepLabel: string;
  heading: string;
  text?: ReactNode;
  extra?: ReactNode;
  children: ReactNode;
}) {
  const { stepLabel, heading, children, extra, done, text } = props;

  return (
    <div className={buildMode.step}>
      <div className={buildMode.header}>
        <div className={buildMode.headerContent}>
          <div className={buildMode.stepLabel({ done, align: "start" })}>
            {stepLabel}
          </div>

          <Heading className={buildMode.heading}>{heading}</Heading>

          <p className={buildMode.info}>{text}</p>
        </div>

        {extra}
      </div>

      {children}
    </div>
  );
}

export function WrapUpStep(props: { stepLabel: string }) {
  const { stepLabel } = props;
  const { gang } = useGangContext();
  const { hasFaction, mode } = gang;

  if (!mode.hasBeenRun) {
    return null;
  }

  return (
    <BuildStep
      done={hasFaction}
      stepLabel={stepLabel}
      heading="Wrap up"
      text={
        <>
          You may{" "}
          <DialogTrigger>
            <ChooseFactionDialog gang={gang} />
            <DialogDisclosure className={interactiveText}>
              pick a faction
            </DialogDisclosure>
          </DialogTrigger>{" "}
          for your gang and assign free weapons if your gits have space. Hit{" "}
          <em className={lacquer}>Done!</em> once you&apos;re ready to unleash
          your gang on the streets of Gnork.
        </>
      }
    >
      <Button
        onClick={async () => {
          const nextMode = gang.mode.setIsDone();
          await database.gangs.updateOne(nextMode.gang.data);
        }}
        className={button({ size: "small", maxInlineSize: "auto" })}
      >
        Done!
      </Button>
    </BuildStep>
  );
}
